import React, { useState, useEffect } from 'react';
import { translations } from '../../translations';
import './Hero.css';

const Hero = ({ language = 'en' }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const t = translations[language]?.hero || translations.en.hero;
  const S3_BASE = 'https://instacarspa.s3.us-east-1.amazonaws.com';
  const slides = [
    {
      image: `${S3_BASE}/13.jpeg`,
      text: t.slide1,
    },
    {
      image: `${S3_BASE}/11.jpeg`,
      text: t.slide2,
    },
    {
      image: `${S3_BASE}/12.jpeg`,
      text: t.slide3,
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="hero" id="H">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero__slide ${index === currentSlide ? 'hero__slide--active' : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="hero__overlay"></div>
          <div className="hero__content">
            <h1
              className="hero__title"
              dangerouslySetInnerHTML={{ __html: slide.text }}
            />
          </div>
        </div>
      ))}
      <div className="hero__pagination">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero__dot ${index === currentSlide ? 'hero__dot--active' : ''}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
